import { DetailBaseData } from '../Models';
import { TYPE_SITE, TYPE_CUSTOMERS, SOURCE_MIH } from '../Constants';

const isOutotecSiteId: (name: string) => boolean = name => /^[sS]-\w+/.test(name);
const isMetsoCustomerId: (name: string) => boolean = name => /^00\d\d\w00000\w{8}$/.test(name);
const isMetsoSource:(item: DetailBaseData) => boolean = item => item.source === SOURCE_MIH;

export const isOutotecSite: (item: DetailBaseData) => boolean = item => item.type === TYPE_SITE && !isMetsoSource(item); // isOutotecSiteId(item.name);
export const isOutotecCustomer: (item: DetailBaseData) => boolean = item => item.type === TYPE_CUSTOMERS && !isMetsoSource(item); // isMetsoCustomerId(item.id);

export const isMetsoSite: (item: DetailBaseData) => boolean = item => item.type === TYPE_SITE && isMetsoSource(item); // !isOutotecSiteId(item.name);
export const isMetsoCustomer: (item: DetailBaseData) => boolean = item => item.type === TYPE_CUSTOMERS && isMetsoSource(item); // && isMetsoCustomerId(item.id);
export const isMetsoData: (item: DetailBaseData) => boolean = item => isMetsoSource(item); // isMetsoCustomer(item) || isMetsoSite(item);
